// extracted by mini-css-extract-plugin
module.exports = {"login":"Login_login__AdCxT","loginBox":"Login_loginBox__JW6am","background":"Login_background__ldAQY","backgroundImage":"Login_backgroundImage__QQ91d"};